import classNames from 'classnames';
import { GearIcon } from '@trello/nachos/icons/gear';
import React from 'react';

import { HeaderButton } from './HeaderButton';
import styles from './DesktopSettingsButton.less';

const noop = () => {};

/**
 * This button has click handler binding in the desktop code via jQuery. Ugh.
 */
export const DesktopSettingsButton: React.FunctionComponent = () => {
  return (
    <HeaderButton
      className={classNames(
        'paws-open-preferences',
        styles.desktopSettingsButton,
        styles.headerButton,
      )}
      icon={<GearIcon />}
      onClick={noop}
    />
  );
};
